import React from 'react'
import { DarkModeToggle } from 'components/DarkModeToggle'

export default function ThemeSwitcher({ referenceElement }: { referenceElement: HTMLDivElement }) {
    return (
        <div className="dark-theme-toggle">
            <DarkModeToggle />
        </div>
    )
}
